/* bristm-feature-spotlight — draws the dotted elbow connectors between each
   feature title and the phone (desktop only) and animates them in once the
   stage scrolls into view. Layout is read with offset* (unaffected by the
   reveal transforms), then the SVG is written in one pass. */
(function () {
  if (window.BRISTM_SPOT) return;
  window.BRISTM_SPOT = true;

  var NS = 'http://www.w3.org/2000/svg';
  var desktop = window.matchMedia('(min-width: 1200px)');
  var GAP = 22; /* distance between a feature column and its start dot */
  var R = 5; /* dot radius */

  function el(name, attrs) {
    var node = document.createElementNS(NS, name);
    for (var k in attrs) node.setAttribute(k, attrs[k]);
    return node;
  }

  function initSpot(root) {
    if (root.dataset.bBound) return;
    root.dataset.bBound = '1';

    var stage = root.querySelector('[data-b-spot-stage]');
    var svg = root.querySelector('[data-b-spot-svg]');
    var phone = root.querySelector('[data-b-spot-phone]');
    if (!stage || !svg || !phone) return;

    var uid = root.id || 'b-spot';
    var frame = 0;

    function draw() {
      frame = 0;
      if (!desktop.matches) {
        svg.replaceChildren();
        return;
      }
      /* ---- read ---- */
      var W = stage.offsetWidth;
      var H = stage.offsetHeight;
      var px = phone.offsetLeft;
      var py = phone.offsetTop;
      var pw = phone.offsetWidth;
      var ph = phone.offsetHeight;
      var items = [];
      root.querySelectorAll('[data-b-spot-feature]').forEach(function (f) {
        var title = f.querySelector('[data-b-spot-title]');
        var col = f.parentElement;
        if (!title || !col) return;
        var left = f.getAttribute('data-side') !== 'right';
        items.push({
          left: left,
          sx: left ? col.offsetLeft + col.offsetWidth + GAP : col.offsetLeft - GAP,
          sy: title.offsetTop + title.offsetHeight / 2, /* offsetParent is the stage */
          ex: left ? px + pw * 0.045 : px + pw * 0.985,
          ey: py + (ph * (parseFloat(f.getAttribute('data-target')) || 50)) / 100,
          bend: (parseFloat(f.getAttribute('data-bend')) || 50) / 100
        });
      });

      /* ---- write ---- */
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var defs = el('defs', {});
      var group = el('g', {});
      items.forEach(function (it, i) {
        /* nearly level lines are drawn straight (Figma: "Bundle Discounts", "Cross-Sell Offers") */
        if (Math.abs(it.ey - it.sy) < 36) it.ey = it.sy;
        var bx = it.sx + (it.ex - it.sx) * it.bend;
        var d =
          it.ey === it.sy
            ? 'M' + it.sx + ' ' + it.sy + 'H' + it.ex
            : 'M' + it.sx + ' ' + it.sy + 'H' + bx + 'V' + it.ey + 'H' + it.ex;
        var id = uid + '-m' + i;
        var mask = el('mask', { id: id, maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: W, height: H });
        mask.appendChild(el('path', { class: 'b-spot__mask-path', d: d, pathLength: 1, style: '--i:' + i }));
        defs.appendChild(mask);
        group.appendChild(el('path', { class: 'b-spot__line', d: d, mask: 'url(#' + id + ')' }));
        group.appendChild(el('circle', { class: 'b-spot__dot', cx: it.sx, cy: it.sy, r: R, style: '--i:' + i }));
        group.appendChild(el('circle', { class: 'b-spot__dot b-spot__dot--end', cx: it.ex, cy: it.ey, r: R, style: '--i:' + i }));
      });
      svg.replaceChildren(defs, group);
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(draw);
    }

    draw();

    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(stage);
    } else {
      window.addEventListener('resize', schedule, { passive: true });
    }
    if (desktop.addEventListener) desktop.addEventListener('change', schedule);
    /* web fonts can shift the titles after first paint */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

    if ('IntersectionObserver' in window && !document.documentElement.classList.contains('shopify-design-mode')) {
      var io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          root.classList.add('is-drawn');
          io.disconnect();
        },
        { threshold: 0.3 }
      );
      io.observe(stage);
    } else {
      root.classList.add('is-drawn');
    }
  }

  function init(scope) {
    var s = scope || document;
    if (s.matches && s.matches('[data-b-spot]')) initSpot(s);
    s.querySelectorAll('[data-b-spot]').forEach(initSpot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
